"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var types_1 = __importDefault(require("../types"));
var createLastMessage_1 = __importDefault(require("./helpers/createLastMessage"));
function chatRoomsReducer(state, action) {
    var _a, _b, _c, _d;
    switch (action.type) {
        case types_1["default"].SET_ROOM_DIRECT_OFFSET: {
            var offset = action.payload;
            return state.merge({ roomsDirectOffset: offset });
        }
        case types_1["default"].SET_ROOM_GROUPS_OFFSET: {
            var offset = action.payload;
            return state.merge({ roomsGroupsOffset: offset });
        }
        case types_1["default"].CREATE_MOCK_DIRECT_ROOM: {
            var _e = action.payload, roomId = _e.roomId, userId = _e.userId;
            var room = {
                _id: roomId,
                isDirect: true,
                isMock: true,
                userId: userId,
                usernames: [],
                messages: [],
                updatedAt: moment_1["default"]().toISOString(),
                lastMessage: '...',
                customFields: {},
                thumbnail: '',
                name: 'Your Coach',
                members: [],
                isGroup: false,
                messageQueue: [],
                unread: 0,
                usersCount: 2,
                storeUpdatedAt: null
            };
            var user = state.users[userId];
            if (user) {
                room.name = user.name;
                room.thumbnail = user.thumbnail;
            }
            var mockIds = lodash_1["default"](state.rooms)
                .toArray()
                .filter({ isMock: true })
                .map('_id')
                .value();
            var rooms = state.rooms;
            rooms = rooms.without.apply(rooms, mockIds); // delete all previous mock rooms
            rooms = rooms.merge((_a = {}, _a[roomId] = room, _a));
            return state.merge({ rooms: rooms });
        }
        case types_1["default"].ADD_ROOM: {
            var roomPayload = action.payload;
            var roomsArr = lodash_1["default"].isArray(roomPayload)
                ? roomPayload
                : [roomPayload];
            var rooms_1 = state.rooms;
            lodash_1["default"].each(roomsArr, function (rcRoom) {
                var _a;
                var _b, _c;
                if (!rcRoom)
                    return null;
                var customFields = rcRoom.customFields;
                var room = {
                    _id: rcRoom._id,
                    isDirect: rcRoom.t === 'd',
                    isGroup: rcRoom.t === 'p',
                    usernames: rcRoom.usernames || [],
                    usersCount: 2,
                    messages: [],
                    updatedAt: moment_1["default"](rcRoom._updatedAt).toISOString(),
                    lastMessage: createLastMessage_1["default"](rcRoom.lastMessage),
                    customFields: customFields,
                    thumbnail: customFields === null || customFields === void 0 ? void 0 : customFields.thumb,
                    name: customFields === null || customFields === void 0 ? void 0 : customFields.name,
                    // type: customFields?.type,
                    // companyName: customFields?.company_name,
                    // companyThumb: customFields?.company_thumb,
                    members: [],
                    storeUpdatedAt: Date.now(),
                    isMuted: lodash_1["default"].includes(customFields === null || customFields === void 0 ? void 0 : customFields.chat_users_mute_room, ((_b = state.me) === null || _b === void 0 ? void 0 : _b._id) || ''),
                    messageQueue: [],
                    unread: 0
                };
                if (rcRoom.t === 'p') {
                    // hide admin user from group
                    room.usersCount = rcRoom.usersCount - 1;
                }
                if (room.isDirect) {
                    room.userId = room._id.replace(((_c = state.me) === null || _c === void 0 ? void 0 : _c._id) || '', '');
                    var user = state.users[room.userId];
                    if (!lodash_1["default"].isEmpty(user)) {
                        room.name = user.name || '';
                        room.thumbnail = user.thumbnail || '';
                    }
                }
                var stateRoom = state.rooms[room._id];
                if (stateRoom) {
                    var roomPrevious = stateRoom.asMutable({ deep: true });
                    room.messages = roomPrevious.messages;
                    room.members = roomPrevious.members;
                    room.messageQueue = roomPrevious.messageQueue;
                    room = __assign(__assign({}, roomPrevious), room);
                }
                rooms_1 = rooms_1.merge((_a = {},
                    _a[room._id] = room,
                    _a));
            });
            return state.merge({ rooms: rooms_1 });
        }
        case types_1["default"].DELETE_ROOM: {
            var roomId = action.payload;
            var ids = lodash_1["default"].isArray(roomId) ? roomId : [roomId];
            return state.merge({
                rooms: (_b = state.rooms).without.apply(_b, ids)
            });
        }
        case types_1["default"].SET_UNREAD: {
            var roomsStatus = action.payload;
            var roomsStatusArr = lodash_1["default"].isArray(roomsStatus) ? roomsStatus : [roomsStatus];
            var rooms_2 = state.rooms;
            lodash_1["default"].each(roomsStatusArr, function (_a) {
                var _b;
                var roomId = _a.roomId, unread = _a.unread;
                var room = rooms_2[roomId];
                if (!room) {
                    console.error('Room.SET_UNREAD: room not found');
                    return null;
                }
                if (room.unread === unread)
                    return null;
                rooms_2 = rooms_2.merge((_b = {},
                    _b[roomId] = room.merge({ unread: unread }),
                    _b));
            });
            return state.merge({ rooms: rooms_2 });
        }
        case types_1["default"].ROOM_MEMBERS_SET: {
            var _f = action.payload, roomId = _f.roomId, members = _f.members;
            var room = state.rooms[roomId];
            room = room.merge({
                members: members.filter(function (_a) {
                    var username = _a.username;
                    return username !== 'admin';
                })
            });
            return state.merge({
                rooms: state.rooms.merge((_c = {},
                    _c[roomId] = room,
                    _c))
            });
        }
        case types_1["default"].SET_ROOM_MUTED: {
            var _g = action.payload, room_id = _g.room_id, is_muted = _g.is_muted;
            var room = state.rooms[room_id];
            if (!room) {
                console.error('Room.SET_ROOM_MUTED: room not found');
                return state;
            }
            room = room.merge({ isMuted: is_muted });
            return state.merge({
                rooms: state.rooms.merge((_d = {},
                    _d[room_id] = room,
                    _d))
            });
        }
        case types_1["default"].SET_CHAT_UPDATE_TIME: {
            var chatUpdateDate = action.payload;
            return state.merge({ chatUpdateDate: chatUpdateDate });
        }
        default:
            return state;
    }
}
exports["default"] = chatRoomsReducer;
